import React, { Fragment, useEffect, useState } from 'react'
import PaginatedComponent from '../common/Pagination/PaginationComponent'
import { Empty } from 'antd'
import { notificationMsg, removeHtmlTags, resHandle } from '../../helper'
import { deleteScheduleService, getcheduleMsgListService } from '../../services/campersServices'
import { ProgramLoader } from '../reuse/SVG'
import UserCard from './UserCard'
import { connect } from 'react-redux'
import { handleNewMsgModalAction } from '../../store/inbox'
import ViewMsgModal from './Modals/ViewMsgModal'
import { Container } from 'react-bootstrap'

const ScheduledMsg = (props) => {
    const [list, setList] = useState([]);
    const [search, setSearch] = useState('');
    const [loader, setLoader] = useState(false);
    const [isMsgModal, setisMsgModal] = useState(false);
    const [activeMsg, setActiveMsg] = useState(null)
    const userId = props.userProfile?._id
    useEffect(() => {
        getList()
    }, [])

    const getList = async (pageNo = 1) => {
        setLoader(true)
        const params = `?isUpcoming=true`
       const res = await  getcheduleMsgListService(params)
        if (res?.data?.statusCode) {
            setList(res.data.responseData.result)
            // setTotalUser(res.data.responseData?.count || 0);
            setLoader(false);
        }
    }
    const findIsStarred = (item, userId) => {
        if (item.hasOwnProperty('starredMsg')) {
            if (item?.starredMsg?.length) return item.starredMsg.find(i => i.userId !== userId).isStarred;
            return false;
        }
        return false;
    };
    const viewMsg = (e, item) => {
        e.stopPropagation()
        setisMsgModal(true)
        setActiveMsg(item)
    };
    const deleteMsg = async (e, item) => {
        e.stopPropagation()
        setActiveMsg(item)
        const params = {
            messageProgramId: item.messageProgramId
        }
        const res = await deleteScheduleService(params)
        if (res?.data?.statusCode) {
            notificationMsg(1, "Message deleted successfuly")
            getList();
        }
    };
    const handleCloseViewModal = () => {
        setisMsgModal(false)
        setActiveMsg(null)
    }

    return (
        <div className="body_container">
            {isMsgModal &&
                <ViewMsgModal
                    activeItem={activeMsg}
                    newMsgModal={isMsgModal}
                    isSchedule={true}
                    handleClose={handleCloseViewModal} />}
            <div style={{ maxHeight: 'calc(100% - 295px)' }}>
                <div className="schedule_user_list_wrapper">

                    <div className="contact_search">
                        <i className="icon-search" />
                        <input
                            type="text"
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            placeholder="Search" />
                    </div>

                    {loader ?
                        <div
                            className="program_loader d-flex align-items-center justify-content-center"
                            style={{ height: '100%' }}
                        >
                            <div>
                                <ProgramLoader />
                            </div>
                        </div> :
                        <ul>
                            {
                                list.length ? list.map(item => (
                                    <li
                                        key={item.groupId}
                                        className={`d-flex align-items-center`}
                                        onClick={(e) => viewMsg(e, item)}
                                    >
                                        {(item.type === 1) && (item.userId?.length > 0) &&
                                                <UserCard
                                                    isSchedule
                                                    item={item}
                                                    findIsStarred={findIsStarred}
                                                    toggleStar={deleteMsg}
                                                    userId={userId}
                                                    timezone={props?.userProfile?.timezone}
                                                />
                                        }

                                        {item.type === 2 ? <Fragment>
                                            <img className="chat_user_img" src={item.groupImage ? item.groupImage : require('../../assets/img/user.png')} alt="" />
                                            <p>
                                                {item.groupName}
                                                <br />
                                                <small>{removeHtmlTags(item.lastMessage)}</small>
                                            </p>

                                        </Fragment> : ''}


                                    </li>
                                )) : <li className="cm_empty"><Empty description="Data Not Found" /></li>
                            }
                        </ul>

                    }


                </div>
                {/* <div className="">
                        <PaginatedComponent
                            activePage={page}
                            itemsCountPerPage={limit}
                            totalItemsCount={totalUser}
                            pageRangeDisplayed={2}
                            onPageChange={handlePageNoChange}
                            isSearch={false}
                        />
                    </div> */}
            </div>



        </div>
    )
}


const mapStateToProps = state => {
    let { userProfile } = state.user;
    let { inboxTab, activeUserChatWindow } = state.inbox;
    return {
        userProfile,
        inboxTab,
        activeUserChatWindow
    };
}

const mapDispatchToProps = dispatch => ({
    handleNewMsgModalAction: params => dispatch(handleNewMsgModalAction(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledMsg);